
let productsApi = {
    async get(token, companyId,params={}, select=[], relationships=[]){
        let response = await window.axios.get('/api/custom_products', {
            params:{
                api_token:token,
                company_logged:companyId,
                ...params,
                select:select,
                relationships:relationships
            }
        });
        return response.data;
    },
    async find(id, token, companyId,params={}){
        let response = await window.axios.get('/api/custom_products/'+id, {
            params:{
                api_token:token,
                company_logged:companyId,
                ...params
            }
        });
        return response.data;
    },
}

export default productsApi